<div class="admin-layout">
  <h4>Fichiers Allocation</h4>
  <div class="flex-vertical oui-elevation-04 background-white rounded width-100pc padding-24 gap-40">
    <div class="flex-horizontal gap-16">
      <oui-textfield
        [control]="filterNameControl"
        label="Rechercher par nom d'allocation"
        class="width-100pc"></oui-textfield>
    </div>
    <app-allocation-table
      [columnSelection]="columnSelection"
      [displayedColumns]="displayedColumns"
      [inputData]="requestResult"
      (requestNewPage)="fetchAllocations()"
      (onRowClick)="onRowClick($event)"></app-allocation-table>
  </div>
</div>
